import React, { useContext, useEffect, useRef, useState } from "react";
import GettingStartedContext from "../utils/GettingStartedContext";

const HelpSidebar = () => {
    const { data, getProperty, langString } = useContext(GettingStartedContext);

    const [faqs, setFAQs] = useState([]);

    const accordion = useRef();

    useEffect(() => {
        window.setTimeout(function () {
            if (accordion.current) {
                $(accordion.current).foundation();
            }
        }, 100);
    }, [accordion]);

    const closeHelpForm = () => {
        const helpDiv = document.getElementById("gsa-help");
        if (helpDiv) {
            helpDiv.classList.toggle("active");
            LiveChatWidget.call("hide");
        }
    };

    if (!data) {
        return null;
    }

    return (
        <div ref={accordion} className="gsa__help" id="gsa-help">
            <div className="gsa__help__container">
                <div className="gsa__help__wrapper">
                    <div className="gsa__help__close">
                        <a onClick={closeHelpForm}>
                            <img src="_resources/themes/airsprint/images/icons/cross.svg" />
                        </a>
                    </div>
                    <div className="gsa__help__content">
                        <div className="gsa__help__section">
                            <h3>{data.HelpTitle}</h3>
                            <p>{data.HelpDescription}</p>
                            <ul className="gsa__help__links">
                                <li>
                                    <a
                                        href={
                                            "tel:" +
                                            getProperty(data, "HelpPhone")
                                        }
                                    >
                                        <span>{langString("CALL") + ": "}</span>
                                        {getProperty(data, "HelpPhoneRead")}
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href={
                                            "mailto:" +
                                            getProperty(data, "HelpEmail")
                                        }
                                    >
                                        <span>
                                            {langString("EMAIL") + ": "}
                                        </span>
                                        {getProperty(data, "HelpEmail")}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="gsa__help__section">
                            <h3>
                                <span>{getProperty(data, "HelpFAQTitle")}</span>
                            </h3>
                            <ul
                                className="accordion"
                                data-accordion={1}
                                data-allow-all-closed="true"
                            >
                                {data.FAQs.map((faq, index) => {
                                    return (
                                        <li
                                            key={index}
                                            className="accordion-item"
                                            data-accordion-item={1}
                                        >
                                            <a
                                                href="#"
                                                className="accordion-title"
                                            >
                                                {faq.Question}
                                            </a>
                                            <div
                                                className="accordion-content"
                                                data-tab-content={1}
                                            >
                                                <p>{faq.Answer}</p>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HelpSidebar;
